import type { Appointments } from "@/lib/appointments"
import { buildAppointmentsCacheStore } from "@/lib/appointments/buildCacheStore"
import type { BookingSearch } from "@/lib/bookingSearch"
import { buildBookingSearchCacheStore } from "@/lib/bookingSearch/buildCacheStore"
import { Caching } from "@/lib/caching"
import { consumeContext } from "@/lib/consume/context"

export namespace Caches {
  export type ContextData = Caching.ContextData<Store>

  export type Key = Caching.Key

  export type Keys = Appointments.OfferingsCache.Keys | BookingSearch.Cache.Keys

  export type PracticeId = Key
  export type StartTime = Key

  export type Store = {
    appointments: Appointments.OfferingsCache.Store
    bookingSearch: BookingSearch.Cache.Store
  }

  export const buildStore = (): Store => {
    return {
      appointments: buildAppointmentsCacheStore(),
      bookingSearch: buildBookingSearchCacheStore(),
    }
  }

  export const Context = Caching.getContext({ buildStore })

  export const consume = consumeContext({
    Context,
    provideTo: `caching`,
  })
}
